var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 23.6481C18.8808 23.6481 23.6481 18.8808 23.6481 13C23.6481 7.11919 18.8808 2.35185 13 2.35185C7.11919 2.35185 2.35185 7.11919 2.35185 13C2.35185 18.8808 7.11919 23.6481 13 23.6481ZM13 25.5C19.9036 25.5 25.5 19.9036 25.5 13C25.5 6.09644 19.9036 0.5 13 0.5C6.09644 0.5 0.5 6.09644 0.5 13C0.5 19.9036 6.09644 25.5 13 25.5Z",
    fill: "#00A0E3",
    stroke: "#00A0E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.074 6.8241C12.7133 6.8241 13.2314 7.34229 13.2314 7.9815V13.3056H18.0926C18.7318 13.3056 19.25 13.8238 19.25 14.463C19.25 15.1022 18.7318 15.6204 18.0926 15.6204H10.9166V7.9815C10.9166 7.34229 11.4348 6.8241 12.074 6.8241Z",
    fill: "#00A0E3",
    stroke: "#00A0E3",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.a4db8440a27cee715d785dd9ab20768d.svg";
export { ForwardRef as ReactComponent };